import { useEffect, useState } from "react";
import { Instagram } from "lucide-react";
import { eventsApi } from "@/services/eventsApi";
import { contact } from "@/data/brand";

const embedUrl = (post) => `https://www.instagram.com/${post.kind}/${post.shortcode}/embed/captioned/`;

const jsonLd = (posts) => JSON.stringify({
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: "Latest from @madminute.official on Instagram",
  itemListElement: posts.map((post, i) => ({
    "@type": "SocialMediaPosting",
    position: i + 1,
    url: post.permalink,
    headline: post.caption || "MADMINUTE Instagram post",
    author: { "@type": "Organization", name: "MADMINUTE", url: "https://www.instagram.com/madminute.official/" },
    datePublished: post.created_at,
  })),
}).replace(/</g, "\\u003c");

export const InstagramFeed = () => {
  const [posts, setPosts] = useState(null);
  useEffect(() => { eventsApi.get("/instagram/feed").then(({ data }) => setPosts(data)).catch(() => setPosts([])); }, []);
  if (!posts || posts.length === 0) return null;
  return (
    <section className="instagram-section section-pad" data-testid="instagram-feed-section">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: jsonLd(posts) }} />
      <div className="section-heading-row">
        <div><p className="eyebrow">Social / @{contact.instagram}</p><h2>LIVE FROM INSTAGRAM</h2></div>
        <a href={`https://instagram.com/${contact.instagram}`} target="_blank" rel="noreferrer" className="instagram-follow-link" data-testid="instagram-follow-link"><Instagram/> Follow us</a>
      </div>
      <div className="instagram-grid" data-testid="instagram-grid">
        {posts.map((post, i) => (
          <article key={post.post_id} className="instagram-card" style={{ "--delay": `${Math.min(i, 5) * 80}ms` }} data-testid={`instagram-post-${i + 1}`}>
            <iframe src={embedUrl(post)} title={post.caption || `MADMINUTE Instagram post ${i + 1}`} loading="lazy" scrolling="no" allowTransparency="true" data-testid={`instagram-embed-${i + 1}`} />
            <footer>
              {post.caption && <p data-testid={`instagram-caption-${i + 1}`}>{post.caption}</p>}
              <a href={post.permalink} target="_blank" rel="noreferrer" data-testid={`instagram-permalink-${i + 1}`}><Instagram/> View on Instagram</a>
            </footer>
          </article>
        ))}
      </div>
    </section>
  );
};
